<template>
  <div style="background: #F8F8F8;">
    <div class="main">
      <div class="side_menu">
        <div class="menu">
          <el-menu ref='menu' @open="handleOpen" @select="selectItems" :active="pageId" :default-active="pageId" :default-openeds="defaultOpenedsArray" :collapse="collapse">
            <template v-for="item in list">
              <router-link :to="item.url" :key="item.id" v-if="item.children.length===0">
                <el-menu-item :index="item.id.toString()">
                  <i class="icon" :class="item.icon"></i>
                  <span slot="title">{{item.name}}</span>
                </el-menu-item>
              </router-link>
              <submenu v-else :dataList="item" :key="item.id"></submenu>
            </template>
          </el-menu>
        </div>
      </div>
      <div class="page-home">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/api/config"
import submenu from "./submenu"
import { httpAjax } from "@/api/ajax";
import { mapActions } from "vuex";

export default {
  name: "newMenu",
  components: { submenu },
  data () {
    return {
      collapse: false, //是否折叠
      list: menuList, //当行菜单数据源
      defaultOpenedsArray: ['10', '20', '30'], //  默认展开
      pageId: '',   //  当前选中id
    }
  },
  watch: {
    $route (to) {
      this.getRouterObg(to)
    }
  },
  mounted () {
    this.getRouterObg(this.$route)
    this.getUserData();
  },
  methods: {
    ...mapActions(['user/getUserData']),
    // 获取用户信息
    getUserData() {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          localStorage.setItem('userData', JSON.stringify(response.data));
          this['user/getUserData']();
        }
      });
    },
    // 当前路由对象
    getRouterObg (to) {
      let routerListItem = this.ruleValidate(this.list, to.path)
      if (routerListItem) {
        sessionStorage.setItem('pageId', routerListItem.id)
        this.pageId = String(routerListItem.id)
      }
    },
    //  返回当前路由对象
    ruleValidate (list, path) {
      let flag = true
      var obg = {}
      function judgeChildren (list) {
        list.forEach(e => {
          if (!flag) {
            return
          }
          if (e.url == path) {
            obg = e
            flag = false
            return
          } else if (e.children && e.children.length) {
            judgeChildren(e.children)
          }
        })
      }
      judgeChildren(list)
      return obg
    },
    selectItems (index) {

    },
    //  展开
    handleOpen (key, keyPath) {

    },
  }
}
</script>

<style scoped lang="less">
.menu {
  padding: 24px;
}

.side_menu {
  width: 272px;
  min-height: calc(100vh - 60px);
  background-color: #ecf1ff;
}

.el-menu {
  border: none;
  background-color: #ecf1ff;

  ::v-deep.el-submenu__title,
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    margin: 6px 0;
    font-weight: 600;
    color: #333333;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    overflow: hidden;
    background: #ecf1ff;
    .iconfont {
      padding-right: 12px;
      color: #333333;
      font-weight: 400;
    }
    .el-submenu__icon-arrow {
      color: #333333;
      font-weight: 400;
    }
  }

  .el-submenu__title:hover {
    background-color: #d6e8ff;
  }

  ::v-deep .el-menu--inline {
    background-color: #ecf1ff;
  }

  ::v-deep.subitem {
    padding-left: 46px !important;
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    overflow: hidden;
    font-weight: 400 !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    background: #ecf1ff;
    margin-bottom: 4px;
  }

  ::v-deep .el-menu-item.is-active {
    width: 224px;
    height: 40px;
    line-height: 40px;
    background: #1170eb !important;
    color: white;
    border-radius: 6px;
    .iconfont {
      color: white;
    }
  }
  .el-menu-item:hover {
    background-color: #d6e8ff;
  }
  ::v-deep.subitem:hover {
    background-color: #d6e8ff;
  }
}

.main {
  display: flex;
  margin: 0 auto;
  .page-home {
    flex: 1;
    box-sizing: border-box;
    overflow: auto;
  }
}
</style>